<script setup lang="ts">
import { FALLBACK } from "~/constants";
import useAsync from "~/hooks/use-async";
import PosterAPI from "~/services/resources/posters";

const { data: mainSlides, loading: loadingSlides, run: loadSlides } = useAsync(PosterAPI.load);

onMounted(loadSlides);
</script>

<template>
  <div v-if="loadingSlides || mainSlides?.length" class="home-slider">
    <BaseSliderSkeleton v-if="loadingSlides" has-controls />
    <BaseSlider
      v-else-if="mainSlides?.length"
      :fallback-variant="FALLBACK.HORIZONTAL_BANNER"
      :slides="mainSlides"
      has-autoplay
      has-controls
      has-indicator
    />
  </div>
</template>

<style lang="scss">
.home-slider {
  @apply aspect-[4/1] lg:aspect-[25/6];
}
</style>
